import {Minimize} from '@material-ui/icons';
import React from 'react';

export function MinimizeIcon() {
  return <Minimize fontSize="small" color="primary" />;
}
